import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OrdersComponent } from './orders.component';
import { AllOrdersComponent } from './all-orders/all-orders.component';
import { NewOrdersComponent } from './new-orders/new-orders.component';
import { OrderLogsComponent } from './order-logs/order-logs.component';


const routes: Routes = [
      {
        path: 'orders',
        data: { title: 'Merchant Orders'
      },
        children: [
          { path: '', component: OrdersComponent },
          {
              path: 'all-orders',
              data: {
                  title: 'Orders'
              },
              component: AllOrdersComponent
          },
          {
              path: 'new-orders',
              data: {
                  title: 'New Orders'
              },
              component: NewOrdersComponent
          },
          {
            path:'order-logs/:orderId',
            data: {
              title: 'Order Logs'
            },
            component: OrderLogsComponent
          }
        ]
      }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OrdersRoutingModule { }
